export default __webpack_public_path__ + "static/media/hero-video-cover-with-play.9f0c0da1.jpg";